import { Button } from "flowbite-react";
import { FaTimes } from "react-icons/fa";
import tenkenTheme from "../../configs/themes/tenkenTheme";
import { useSelector } from "react-redux";
import {
  isButtonProcessing,
  getButtonProcessingClass,
} from "../../utils/common-utils";

const ButtonCancel = (props) => {
  const buttonProcessingState = useSelector((state) => state.button_processing);
  const isProcessing = isButtonProcessing(buttonProcessingState, props);
  const processingClass = getButtonProcessingClass(isProcessing);
  const tmpProps = {
    ...props,
    theme: tenkenTheme.button,
    color: 'dark',
    className: `rounded-[6px] lg:h-10 h-[38px]  ${props.className} ${processingClass}`,
    isProcessing,
  };

  return (
    <Button {...tmpProps}>
      <FaTimes className="mr-[4px] lg:h-5 lg:w-5 h-[18px] w-[18px]" />
      {props.children}
    </Button>
  );
};

export default ButtonCancel;
